import type {
  Cin7CustomerAddress,
  Cin7CustomerChild,
  Cin7CustomerContact,
} from "@/api/dtos";
import type {
  CustomerAddress,
  CustomerChild,
  CustomerContact,
} from "@/api/customer/_models/Customer";

export const toCustomerAddressFromCin7CustomerAddress = (
  a: Cin7CustomerAddress,
): CustomerAddress => {
  return {
    id: a.ID ?? null,
    line1: a.Line1,
    line2: a.Line2,
    city: a.City,
    state: a.State,
    postcode: a.Postcode,
    country: a.Country,
    type: a.Type,
    isDefault: a.DefaultForType,
  };
};

/** IDs are server-assigned, so they're omitted from the create payload. */
export const toCin7CustomerAddressFromCustomerAddress = (
  a: CustomerAddress,
): Cin7CustomerAddress => {
  return {
    Line1: a.line1,
    Line2: a.line2,
    City: a.city,
    State: a.state,
    Postcode: a.postcode,
    Country: a.country,
    Type: a.type,
    DefaultForType: a.isDefault,
  };
};

export const toCustomerContactFromCin7CustomerContact = (
  c: Cin7CustomerContact,
): CustomerContact => {
  return {
    id: c.ID ?? null,
    name: c.Name,
    jobTitle: c.JobTitle,
    phone: c.Phone,
    mobilePhone: c.MobilePhone,
    fax: c.Fax,
    email: c.Email,
    website: c.Website,
    isDefault: c.Default,
    comment: c.Comment,
    includeInEmail: c.IncludeInEmail,
    marketingConsent: c.MarketingConsent,
  };
};

export const toCin7CustomerContactFromCustomerContact = (
  c: CustomerContact,
): Cin7CustomerContact => {
  return {
    Name: c.name,
    JobTitle: c.jobTitle,
    Phone: c.phone,
    MobilePhone: c.mobilePhone,
    Fax: c.fax,
    Email: c.email,
    Website: c.website,
    Default: c.isDefault,
    Comment: c.comment,
    IncludeInEmail: c.includeInEmail,
    MarketingConsent: c.marketingConsent,
  };
};

export const toCustomerChildFromCin7CustomerChild = (
  c: Cin7CustomerChild,
): CustomerChild => {
  return {
    id: c.CustomerID,
    name: c.CustomerName,
  };
};

/** Cin7's comma-delimited tag string (or null) to a list. */
export const tagsFromCin7 = (value: string | null): string[] => {
  return value ? value.split(",").map((t) => t.trim()).filter(Boolean) : [];
};

/** A tag list to Cin7's comma-delimited string; empty = null. */
export const tagsToCin7 = (tags: string[]): string | null => {
  return tags.length ? tags.join(",") : null;
};
